const baseURL = 'https://bootcamp.akbolat.net/';

export default baseURL;